export enum OrdersActionTypes {
    API_RESPONSE_SUCCESS = "@@orders/API_RESPONSE_SUCCESS",
    API_RESPONSE_ERROR = "@@orders/API_RESPONSE_ERROR",
    GET_ORDERS = "@@orders/GET_ORDERS",
    GET_ORDERS_REVENUE = "@@orders/GET_ORDERS_REVENUE",
  }